module.exports = __webpack_public_path__ + "img/moonfon.c991b04d.png";